import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as MBLogo } from '../../../Assets/Images/logo.svg';
import { ReactComponent as HamburgerMenuIcon } from '../../../Assets/Images/hamburger-menu.svg';
import { ReactComponent as HamburgerCloseIcon } from '../../../Assets/Images/hamburger-close.svg';

function TopHeader({ menuOpen, setMenuOpen }) {
	const { t, i18n } = useTranslation();

	const languageOptions = ['en', 'de'];
	const currentLanguage = i18n.language?.split('-')[0] || 'en';

	const onLanguageChange = useCallback(
		(lang) => {
			i18n.changeLanguage(lang);
		},
		[i18n]
	);

	return (
		<div className="top-header">
			<div className="top-header__inner">
				<button
					type="button"
					className={`top-header__hamburger${menuOpen ? ' top-header__hamburger--open' : ''}`}
					onClick={() => setMenuOpen((open) => !open)}
					aria-label="Toggle navigation"
					aria-expanded={menuOpen}
					data-testid="top-header-hamburger"
				>
					<span className="top-header__hamburger-icon" aria-hidden="true">
						<HamburgerMenuIcon className="top-header__hamburger-svg top-header__hamburger-svg--menu" />
						<HamburgerCloseIcon className="top-header__hamburger-svg top-header__hamburger-svg--close" />
					</span>
				</button>

				<Link
					className="logo"
					to="/home"
					title="Go to the Mercedes-Benz Connectivity Services home page"
					data-testid="top-header-home-link"
				>
					<MBLogo className="top-header__logo" data-testid="top-header-logo" />
				</Link>

				<div className="top-header__actions">
					<a
						className="top-header__imprint"
						href={t('mainScreen.topHeader.imprintUrl')}
						rel="noopener noreferrer"
						target="_blank"
						data-testid="top-header-imprint"
					>
						{t('mainScreen.topHeader.imprint')}
					</a>

					<div className="top-header__lang-switcher" aria-label="Language switcher">
						{languageOptions.map((lang) => (
							<button
								key={lang}
								type="button"
								className={`top-header__lang-btn${
									currentLanguage === lang ? ' top-header__lang-btn--active' : ''
								}`}
								onClick={() => onLanguageChange(lang)}
								data-testid={`top-header-lang-${lang}`}
							>
								{lang}
							</button>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}

export default TopHeader;